import React from 'react';
import PropTypes from 'prop-types';
import Phone from '@mui/icons-material/Phone';
import { FormattedMessage } from 'react-intl';

const PhoneCallParticipants = ({ voiceCalls }) => {
  if (voiceCalls.length === 0) return null;

  return (
    <div className="phone-call-participants">
      <p className="phone-call-participants__title">
        <FormattedMessage defaultMessage="Phone call participants" />
      </p>
      <ul className="phone-call-participants__list">
        {voiceCalls.map(call => (
          <li key={call.id} className="phone-call-participants__item">
            <span className="phone-call-participants__icon">
              <Phone fontSize="small" />
            </span>
            <span className="phone-call-participants__number">
              <FormattedMessage
                defaultMessage="Phone call •••• {last4}"
                values={{ last4: call.from_number_last4 }}
              />
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

PhoneCallParticipants.propTypes = {
  voiceCalls: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      from_number_last4: PropTypes.string.isRequired,
      video_session_connection_id: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default PhoneCallParticipants;
